import { CartItems } from "components/Cart/Items";
import { CartSummary } from "components/Cart/Summary";
import { CartRemove } from "components/Cart/Remove";
import "./Product.scss";

/**
 * Component: CartProduct
*/
export function CartProduct() {
  console.log("CartProduct mounted.");
  CartItems();
  CartSummary();
  CartRemove();
}
